import { initFederation } from '@angular-architects/module-federation';

initFederation('/assets/mf.manifest.json')
    .catch((err) => console.error(`Error during federation initialization: ${err}`))
    .then(async (_) => import('./bootstrap'))
    .catch((err) => console.error(`Error during app bootstrap: ${err}`));
// Force build 11/24/2025 3:02 PM CT
